import React, { MouseEventHandler } from 'react';

import { css } from '@emotion/react';

import { colors, fontSizes, fontWeights, gutterSizes, lineHeights } from '../base/theme';

const styles = css`
    margin-bottom: ${gutterSizes.medium};
    color: ${colors.navy};
    background-color: ${colors.white};
    border: 1px solid ${colors.newGrey};
    padding: 4px ${gutterSizes.medium} 4px ${gutterSizes.medium};
    border-radius: 50px;

    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.light};
    line-height: ${lineHeights.medium};
    text-align: left;

    flex-shrink: 0; // Prevents the chip from wrapping to the next line

    cursor: pointer;

    :hover {
        background-color: ${colors.branch5};
    }
`;

const Chip = ({
    children,
    href,
    onClick,
}: {
    children: React.ReactNode;
    href?: string;
    onClick?: MouseEventHandler;
}) => {
    const Element = href ? 'a' : 'button';

    const props: {
        href?: string;
        onClick?: MouseEventHandler;
        type?: 'button' | 'submit' | 'reset';
    } = {};
    if (href) {
        props.href = href;
    } else {
        props.type = 'button';
    }
    if (onClick) {
        props.onClick = onClick;
    }

    return (
        <Element css={styles} {...props}>
            {children}
        </Element>
    );
};

export default Chip;
